import { Icons, Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { ExecuteBlock } from '../styled'

interface ButtonProps {
  taskId: string
  refetch: () => void
  hideCurrentStatus?: boolean
}

export const SetTaskToWorkButton: FC<ButtonProps> = ({ taskId, refetch, hideCurrentStatus }) => {
  const { t } = useTranslation(['my_tasks', 'common'])
  const notify = useNotification()

  const [progress, setToWork] = useAProgress(() => apiClient.post(endpoints.setTaskToWork(taskId)), {
    eventName: 'setToWork',
    analyticsPayload: {
      id: taskId,
    },
    onSuccess: () => {
      refetch()
      notify(Progress.SUCCESS, { title: t('table.set_to_work_task') })
    },
    onError: () => notify(Progress.ERROR, { title: t('common:notifyError') }),
  })

  return (
    <ExecuteBlock>
      {!hideCurrentStatus && (
        <>
          <span>{t('table.new')}</span>
          <Icons.IconArrowRightM height={20} width={20} />
        </>
      )}
      <AButton id="setToWork" color="secondary" onClick={setToWork} progress={progress}>
        {t('detail.to_work')}
      </AButton>
    </ExecuteBlock>
  )
}

export const CompleteTaskButton: FC<ButtonProps> = ({ taskId, refetch }) => {
  const { t } = useTranslation('my_tasks')
  const notify = useNotification()

  const [progress, completeTask] = useAProgress(() => apiClient.post(endpoints.completeTask(taskId)), {
    eventName: 'complete',
    analyticsPayload: {
      id: taskId,
    },
    onSuccess: () => {
      refetch()
      notify(Progress.SUCCESS, { title: t('table.completed_task') })
    },
  })

  return (
    <ExecuteBlock>
      <span>{t('table.in_progress')}</span>
      <Icons.IconArrowRightM width={20} height={20} />
      <AButton id="completeTask" color="secondary" onClick={completeTask} progress={progress}>
        {t('detail.perform')}
      </AButton>
    </ExecuteBlock>
  )
}
